<template>
  <li class="dropdown-option row align-items-center option-link">
    <a v-if="data.url" :href="data.url" target="_blank" rel='noopener noreferrer' :aria-label="data.text">
      {{data.text}}
      <i v-if="data.icon" :class="data.icon" class="icon xs ml-2"></i>
    </a>
    <span v-else>{{data.text}}</span>
  </li>
</template>

<script>

export default {
  name: 'OptionLink',
  props: {
    data: Object
  }
}
</script>

<style lang="scss" scoped>
.options-content .option-link {
  margin: 0;
  padding: 0.8rem 1.5rem;
}
</style>
